export const checkVersion = () => {
  // 获取或生成版本号
  const currentVersion = process.env.REACT_APP_VERSION || "initial_version";
  const cachedVersion = localStorage.getItem("app_version");

  // 调试信息
  console.log("当前版本号:", currentVersion);
  console.log("缓存版本号:", cachedVersion);

  // 如果没有缓存的版本号，保存当前版本号
  if (!cachedVersion) {
    console.log("首次访问，保存版本号");
    localStorage.setItem("app_version", currentVersion);
    // 强制刷新页面
    window.location.reload(true);
    return;
  }

  // 如果版本号不同，清除缓存并刷新
  if (cachedVersion !== currentVersion) {
    console.log("版本不匹配，准备刷新");
    // 清除所有缓存数据
    localStorage.clear();
    // 保存新版本号
    localStorage.setItem("app_version", currentVersion);
    // 强制刷新页面
    window.location.reload(true);
  }
};
